import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MultiRepCard from "../../MultiRepCard.js";
import MustRefer from "../../MustRefer.js";
import ClauseCard from "../../ClauseCard.js";
import clauseCardDesc from "../../../data/Ontario/clauseCardDescription.js";
import clauseData from "../../../data/Ontario/clauseData.js";
import importantNotes from "../../../data/Ontario/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";

export default function PreConPurchase() {
  const [BuyerDocs, setBuyerDocs] = useState([
    "RECO Info Guide Acknowledgement",
    "Buyer Representation Agreement with Schedule A (371)",
    "Related FINTRAC Documents",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Builder's Sale Agreement w/ Tarion Addendums",
    "Schedule B1 (if eXp holding deposit)",
    "Confirmation of Co-operation (320)",
    "Copy of Deposit & Receipt",
    "Full REALTOR® SOLD MLS Printout",
  ]);

  const ReferralRepDocs = [
    "RECO Info Guide Acknowledgement",
    "Buyer Representation Agreement with Schedule A (371)",
  ];

  const PreConReferralData = [
    "Builder's Sale Agreement w/ Tarion Addendums",
    "Builder Referral/Commission Agreement or FORM 641 if Builder does not have a Referral Form",
  ];

  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [ListingType, setListingType] = useState("MLS");
  const [BuyerRep, setBuyerRep] = useState("Client");
  const [SellerRep, setSellerRep] = useState("YesNotMe");

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const addDisclosure = (e) => {
    setIsDisclosure(e.target.value);

    if (
      DealDocs.includes("Registrant's Disclosure of Interest (160 or 161)") ===
      true
    ) {
      return;
    } else {
      setDealDocs([
        ...DealDocs,
        "Registrant's Disclosure of Interest (160 or 161)",
      ]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure(e.target.value);
    setDealDocs(
      DealDocs.filter(
        (item) => item !== "Registrant's Disclosure of Interest (160 or 161)"
      )
    );
  };

  const setExclusive = (e) => {
    setListingType("Exclusive");
    setDealDocs(
      DealDocs.filter((item) => item !== "Full REALTOR® SOLD MLS Printout")
    );
  };

  const setMLS = (e) => {
    setListingType(e.target.value);

    if (DealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
      return;
    } else {
      setDealDocs([...DealDocs, "Full REALTOR® SOLD MLS Printout"]);
    }
  };

  const handleSellerRep = (e) => {
    setSellerRep(e.target.value);
    if (e.target.value === "Yes") {
      setListingType("MLS");
      if (DealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
        return;
      } else {
        setDealDocs([...DealDocs, "Full REALTOR® SOLD MLS Printout"]);
      }
    }
    if (e.target.value === "No" || e.target.value === "YesNotMe") {
      setBuyerRep("Client");
      setListingType("MLS");
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "Buyer Representation Agreement with Schedule A (371)",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const handleBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "Client") {
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "Buyer Representation Agreement with Schedule A (371)",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "RECO Self-Represented Disclosure Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 pt-3">
            Is the Builder Represented by an Agent?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                column
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="YesNotMe"
                value={SellerRep}
              >
                <FormControlLabel
                  value="YesNotMe"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="Yes, by another agent/brokerage"
                />
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="Yes, I represent the builder"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {SellerRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">Buyer's Representation Choice?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="Client"
                    value={BuyerRep}
                  >
                    <FormControlLabel
                      value="Client"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="SRP"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Self-Represented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}

          {SellerRep === "No" ? (
            ""
          ) : (
            <>
              <div className="pr-5 pt-5">Type of Listing?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="MLS"
                    value={ListingType}
                  >
                    <FormControlLabel
                      value="MLS"
                      control={<Radio size="small" onClick={setMLS} />}
                      label="MLS"
                    />
                    <FormControlLabel
                      value="Exclusive"
                      control={<Radio size="small" onClick={setExclusive} />}
                      label="Exclusive"
                    />
                    {SellerRep !== "Yes" ? (
                      <>
                        <FormControlLabel
                          value="Mere"
                          control={<Radio size="small" onClick={setMLS} />}
                          label="Mere Posting"
                        />
                      </>
                    ) : (
                      ""
                    )}
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>

              <div className="pr-5 pt-5">
                {SellerRep === "Yes"
                  ? `Are you or any of your close relatives the Buyer or the Seller?`
                  : `Are you or close relatives purchasing this property?`}
              </div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue={IsDisclosure}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio size="small" onClick={addDisclosure} />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={
                        <Radio size="small" onClick={removeDisclosure} />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          )}
        </div>
        {ListingType === "Mere" ? (
          <>
            <div className="paragraph">
              <p>
                <strong>Important:</strong> Even though the listing brokerage is
                providing less services, they still have a representation
                agreement with the Builder/Seller. Usually, the deposit for
                pre-construction is placed into the Builders Trust Account. If
                this is not the case, eXp should hold the deposit, as the
                listing brokerage typically does not.
                <br />
                <br />
                <strong>FORM 320: </strong>Please ensure commission is clearly
                defined on FORM 320. In the commission section of FORM 320,
                check 4b-2 and put{" "}
                <em>
                  "[the commission amount] as per the remuneration clause in the
                  agreement"
                </em>
                . Make sure you include a Remuneration Clause in the Purchase
                Agreement to cover the agreed upon commission. It is common for
                the listing brokerage to decline signing this form. Be sure to
                have the other parties sign.
                <br />
                <br />
                <strong>
                  Remuneration Clause (may have to adjust as new builds
                  typically pay NET HST):
                  <br />
                </strong>
                The Buyer directs the Seller and the Seller agrees to pay the
                Buyer's closing credit equal to _____ of the Purchase Price,
                plus applicable Harmonized Sales Tax (HST), to the Buyer's
                Brokerage, eXp Realty, at the closing of the transaction by the
                Seller's lawyer/representative. This payment is to be made to
                satisfy the Buyer's Buyer Representation Agreement (BRA) with
                eXp Realty, Brokerage.
              </p>
            </div>
          </>
        ) : (
          ""
        )}
      </div>

      {SellerRep === "YesNotMe" ? (
        <ChecklistCard
          province={"ON"}
          CheckListData={BuyerDocs}
          CheckListData2={DealDocs}
          Header={"Pre-Construction Purchase:"}
          Header2={"Buyer Client"}
          Title1="Buyer Representation Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}

      {SellerRep === "Yes" && BuyerRep === "Client" && IsDisclosure === "No" ? (
        <>
          <MultiRepCard />
          <ChecklistCard
            province={"ON"}
            CheckListData={BuyerDocs}
            CheckListData2={DealDocs}
            Header={"Pre-Construction Purchase:"}
            Header2={"Buyer Client"}
            Title1="Buyer Representation Documents"
            Title2="Deal Documents"
          />
        </>
      ) : (
        ""
      )}
      {SellerRep === "Yes" && BuyerRep === "SRP" ? (
        <ChecklistCard
          province={"ON"}
          CheckListData={BuyerDocs}
          CheckListData2={DealDocs}
          Header={"Pre-Construction Purchase:"}
          Header2={"Buyer is a SRP"}
          Title1="Buyer Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}
      {SellerRep === "No" ? (
        <ChecklistCard
          province={"ON"}
          CheckListData={ReferralRepDocs}
          CheckListData2={PreConReferralData}
          Header={"Pre-Construction Purchase:"}
          Header2={"Referral of Buyer Client to Builder"}
          Title1="Buyer Representation Documents"
          Title2="Deal Documents"
        />
      ) : (
        ""
      )}

      {SellerRep === "Yes" &&
      BuyerRep === "Client" &&
      IsDisclosure === "Yes" ? (
        <MustRefer IsMLS={ListingType} />
      ) : (
        ""
      )}

      {SellerRep === "Yes" &&
      BuyerRep === "Client" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter(
            (item) => item.category.includes("precon") === true
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              item.category.includes("precon") === true &&
              item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) =>
              item.category.includes("precon") === true &&
              item.isCommon === "no"
          )}
          PurchaseType="PreCon"
        />
      )}
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("precon") === true
          )}
        />
        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true
            )}
          />
        ) : (
          ""
        )}
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("purchase") === true
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
